import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'

const officeApi = createApi({
  reducerPath: 'officeApi',
  baseQuery: fetchBaseQuery({ baseUrl: '/api/v1/accounts/offices' }),
  endpoints: (builder) => ({
    getOffices: builder.query({
      query: (searchParams = '') => ({ url: searchParams }),
      providesTags: ['Office']
    }),
    getOffice: builder.query({
      query: (id) => ({ url: `/${id}` }),
      providesTags: ['Office']
    }),
    createOffice: builder.mutation({
      query: (body) => ({
        method: 'POST',
        body: { office: body }
      }),
      invalidatesTags: ['Office']
    }),
    updateOffice: builder.mutation({
      query: ({ id, ...body }) => ({
        url: `${id}`,
        method: 'PATCH',
        body: { office: body }
      }),
      invalidatesTags: ['Office']
    })
  })
})

export const { useGetOfficesQuery, useCreateOfficeMutation, useUpdateOfficeMutation, useGetOfficeQuery } = officeApi
export { officeApi }
